import {
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";
import { apiClient } from "./api-client";

export const refundKeys = {
  all: () => ["refund"],
  mine: (params) => ["refund", "mine", params],
};

/**
 * @param {{ page?: number; limit?: number; status?: string }} params
 */
export function fetchRefundMine({ page = 1, limit = 10, status = "pending" } = {}) {
  return apiClient({
    url: "refund/mine",
    method: "GET",
    params: { page, limit, status },
  });
}

/**
 * @param {{ page?: number; limit?: number; status?: string }} filters
 * @param {{ enabled?: boolean }} [options]
 */
export function useRefundMineQuery(filters, options) {
  return useQuery({
    queryKey: refundKeys.mine(filters),
    queryFn: () => fetchRefundMine(filters),
    placeholderData: (prev) => prev,
    enabled: options?.enabled !== false,
  });
}

export function extractRefundRows(payload) {
  if (!payload) return [];
  if (Array.isArray(payload.data)) return payload.data;
  return [];
}

export function extractRefundTotal(payload) {
  if (payload == null) return 0;
  const n = payload.total;
  if (typeof n === "number" && !Number.isNaN(n)) return n;
  return extractRefundRows(payload).length;
}

export function useRefundRequest() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload) =>
      apiClient({
        url: "refund/request",
        method: "POST",
        data: payload,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["refund", "mine"] });
    },
  });
}

export function useRefundVerify() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload) =>
      apiClient({
        url: "refund/verify",
        method: "POST",
        data: payload,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["refund", "mine"] });
    },
  });
}
